module.exports = __webpack_public_path__ + "img/occidental-resort-3.2f32a97e.jpg";